import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { REACT_APP_GLOBAL_API_BASE_URL_V2 } from 'runtimeEnvVars';

import { setApplicantNotesAction } from 'containers/ApplicantTableV2/actions';
import { addDefaultErrorMessageAction } from 'containers/FlashMessage/actions';
import { addApplicantsInvalidatedListener } from 'utils/appEvents';
import { apiGet } from 'utils/axios';

export default function useApplicantNotes(applicantId) {
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = useCallback(async () => {
    if (!applicantId) return;
    setIsLoading(true);
    try {
      const url = `${REACT_APP_GLOBAL_API_BASE_URL_V2}/applicants/${applicantId}/notes`;
      const res = await apiGet(url);
      if (res.data) {
        dispatch(setApplicantNotesAction(applicantId, res.data.notes));
        setError(null);
      }
    } catch (e) {
      setError(e);
    } finally {
      setIsLoading(false);
    }
  }, [applicantId, dispatch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Refetch notes when copilot invalidates this applicant
  useEffect(() => {
    if (!applicantId) return undefined;

    return addApplicantsInvalidatedListener(event => {
      if (event.detail?.applicantIds?.includes(applicantId)) {
        fetchData();
      }
    });
  }, [applicantId, fetchData]);

  useEffect(() => {
    if (error) {
      dispatch(addDefaultErrorMessageAction());
    }
  }, [dispatch, error]);

  return { isLoading };
}
